import { FleetReportData, FleetReportsFilters } from "types/FleetReports";
import { useTypeSelectors } from "./useTypeSelectors";

const matchesFleetSearch = (item: FleetReportData, search?: string) => {
  const query = (search || "").trim().toLowerCase();
  if (!query) return true;
  return [item.van_number, item.plate, item.vin].some((value) =>
    `${value || ""}`.toLowerCase().includes(query),
  );
};

export const getFilteredFleetReports = (
  fleetReportsData: FleetReportData[] = [],
  fleetReportFilters: FleetReportsFilters,
) => {
  const invoiceStatus = Number(fleetReportFilters.invoice);

  return fleetReportsData
    .filter((item) => matchesFleetSearch(item, fleetReportFilters.search))
    .filter((item) => {
      const hasInvoice = Number(item.invoice) > 0;
      if (invoiceStatus === 1) return hasInvoice;
      if (invoiceStatus === 2) return !hasInvoice;
      return true;
    })
    .filter((item) =>
      fleetReportFilters.company ? item.company_id === fleetReportFilters.company : true,
    )
    .filter((item) =>
      fleetReportFilters?.statuses?.length
        ? fleetReportFilters?.statuses?.includes(item.status)
        : true,
    )
    .sort(
      getComparator(
        fleetReportFilters?.ordering?.includes("-") ? "desc" : "asc",
        fleetReportFilters?.ordering?.replace("-", ""),
      ),
    );
};

export const getVisibleFleetReportRows = (
  fleetReportList: FleetReportData[] = [],
  offBoardedFleetReportList: FleetReportData[] = [],
  fleetReportFilters: FleetReportsFilters,
) => {
  const offBoardedRows = fleetReportFilters?.showActual
    ? []
    : getFilteredFleetReports(offBoardedFleetReportList, fleetReportFilters);
  const actualRows = getFilteredFleetReports(fleetReportList, fleetReportFilters);

  return { offBoardedRows, actualRows };
};

const useFilteredFleetReports = (fleetReportsData: FleetReportData[]) => {
  const { fleetReportFilters } = useTypeSelectors((state) => state.fleetReports);
  return getFilteredFleetReports(fleetReportsData, fleetReportFilters);
};

function getComparator(
  order: "asc" | "desc",
  orderBy: keyof FleetReportData | string,
): (a: FleetReportData, b: FleetReportData) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function descendingComparator(a: any, b: any, orderBy: keyof FleetReportData | string) {
  if (a[orderBy] === null) return 1;
  if (b[orderBy] === null) return -1;
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

export default useFilteredFleetReports;
